import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import environment from "environment";

function YoutubeCallBack(props) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    let token;
    if (localStorage.getItem("Auth") !== null) {
      token = JSON.parse(localStorage.getItem("Auth")).access_token;
    }

    let url = `${
      environment.api.baseApi
    }/influencer_youtube_auth?code=${searchParams.get(
      "code"
    )}&state=${searchParams.get("state")}`;

    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        navigate("/influencersPlatform");
      })
      .catch(() => {
        alert("internal server error");
        navigate("/influencersPlatform");
      });
  });
}
export default YoutubeCallBack;
